<template>
  <div>
    <van-notice-bar :text="$t('column.Add_item')"/>
    <van-form @submit="onSubmit">
      <van-field
        v-model="shop_name"
        :name="$t('column.Trade_name')"
        :label="$t('column.Trade_name')"
        :placeholder="$t('column.Trade_name')"
        :rules="[{ required: true, message: this.$t('column.Please_fill_the_product_name') }]"
      />
      <van-field
        v-model="shop_price"
        :name="$t('column.commodity_price')"
        :label="$t('column.commodity_price')"
        :placeholder="$t('column.commodity_price')"
        :rules="[{ required: true, message: this.$t('column.Please_fill_commodity_price') }]"
      />
      <van-field name="shop_logo" :label="$t('column.Product_picture')">
        <template #input>
          <van-uploader :after-read="afterRead" v-model="fileList" multiple :max-count="1"/>
        </template>
      </van-field>

      <van-field
        v-model="shop_url"
        :name="$t('column.Product_external_links')"
        :label="$t('column.Product_external_links')"
        :placeholder="$t('column.Product_external_links')"
        :rules="[{ required: true, message: this.$t('column.Please_fill_product_external_link') }]"
      />
      <div style="margin: 16px;">
        <van-button type="primary" round block native-type="submit">{{ $t('column.Add_item')}}</van-button>
      </div>
    </van-form>
  </div>

</template>

<script>
    import axios from "axios";
    import Toast from "vant/lib/toast"
    import qs from 'qs'

    axios.interceptors.request.use((config) => {
        if (config.method === "post") {
            config.data = qs.stringify(config.data);
            config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });

    let OSS = require('ali-oss');
    export default {
        name: "shop_add",
        data() {
            return {
                shop_price: '',
                shop_name: '',
                shop_url: '',
                fileList: [],
                dataObj: {
                    region: '',
                    accessKeyId: '',
                    accessKeySecret: '',
                    bucket: '',

                }, //存签名信息
                baseAli: '',
            }
        },
        created: function () {
            document.title = this.$t('title.shop_add')
            this.initInfo();
        },
        methods: {
            initInfo() {
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=get_create_info", {
                    params: {
                        token: token,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        return;
                    }
                    this.dataObj.region = res.data.region;
                    this.dataObj.accessKeyId = res.data.accessKeyId;
                    this.dataObj.accessKeySecret = res.data.accessKeySecret;
                    this.dataObj.bucket = res.data.bucket;
                    this.baseAli = res.data.endpoint;
                });
            },
            afterRead(file) {
                // 此时可以自行将文件上传至服务器
                //console.log(file);
                const that = this;
                //判断扩展名
                const tmpcnt = file.file.name.lastIndexOf(".");
                const exname = file.file.name.substring(tmpcnt + 1);
                const names = ['jpg', 'jpeg', 'webp', 'png', 'bmp'];
                if (names.indexOf(exname) < 0) {
                    Toast(this.$t('Tips.format_not_supported'));
                    return
                }

                let client = new OSS(this.dataObj);

                async function multipartUpload() {

                    const fileName = file.file.name;
                    //定义唯一的文件名，打印出来的uid其实就是时间戳
                    //client 是第一步中的 client
                    client.multipartUpload(fileName, file.file,
                        {
                            progress: function (p) { //获取进度条的值
                                console.log(p);
                                that.progress = p * 100
                            },

                        }).then(
                        result => {
                            //下面是如果对返回结果再进行处理，根据项目需要
                            // console.log(result)
                            that.shop_logo_url = 'http://' + that.baseAli + '/' + result.name
                            console.log(that.shop_logo_url);

                        }).catch(err => {
                        console.log("err:", err)
                    })
                }

                multipartUpload();
            },
            onSubmit() {
                const token = this.$route.query.token;
                let params = {
                    params: {
                        token: token,
                        shop_logo_url: this.shop_logo_url,
                        shop_name: this.shop_name,
                        shop_price: this.shop_price,
                        shop_url: Base64.encode(this.shop_url),
                    }
                };
                axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=myshop&act=add_shop_product", params).then(res => {
                    console.log(res.data);
                    if (res.data.status === 0) {
                        Toast(res.data.error);
                        return;
                    }
                    window.location.reload();
                    Toast(this.$t('Tips.Added_successfully'));
                });
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/shop_add.vue